<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      template(v-if="pageLvl == 'vip'")
        .form-group.col-6.mb-1(v-if="isEditAccess")
          b-button.ml-1(v-if="vipCount < vipCountMax" v-b-modal.addVip type="button" variant="info" size="sm")
            i.fa.fa-plus
            span.ml-1 {{ $t("ui.combine.add_vip") }}
      template(v-else)
        .form-group.col-6.mb-1
          SubmitButton(
            :loading="loading"
            icon="icon-arrow-left"
            :text="$t('ui.back')"
            type="button"
            @click="backToVipList"
            variant="secondary"
            size="sm"
          )
  .card-body
    .row
      .col-12
        template(v-if="pageLvl == 'vipProvider' && selectedVipId != null")
          h4 {{ selectedVipId + " - " + selectedVipName }}
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.sticky-position.text-center(width="5%")
                    span #
                  th.sticky-position(width="15%")
                    span(:title="$t('ui.provider_code')") {{ $t('ui.provider_code') }}
                  th.sticky-position(width="25%")
                    span(:title="$t('ui.provider_name')") {{ $t('ui.provider_name') }}
                  th.sticky-position.text-center(width="20%")
                    b-form-checkbox.vipCheckbox(
                      size="sm"
                      v-model="srr"
                      :title="$t('ui.self_rebate_rate')"
                      @input="confirmCopyAll('srr', $event, 'self_rebate_rate')"
                    ) {{ $t("ui.self_rebate_rate") }}
                  th.sticky-position.text-center(width="20%")
                    b-form-checkbox.vipCheckbox(
                      size="sm"
                      v-model="drr"
                      :title="$t('ui.downline_rebate_rate')"
                      @input="confirmCopyAll('drr', $event, 'downline_rebate_rate')"
                    ) {{ $t("ui.downline_rebate_rate") }}
                  th.text-center.sticky-position(width="10%")
                    span(:title="$t('ui.action')") {{ $t("ui.action") }}
                    span.ml-1
                      a.fa.fa-lg.fa-edit.text-warning(href="javascript:void(0)" @click="confirmVipProviderRebateBatch()" :title="$t('ui.edit_batch')")
              tbody.clusterize-content
                tr(v-if="vipProviderList.length == 0")
                  td(colspan="6").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in vipProviderList")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.provider_code") {{ item.provider_code }}
                  td
                    span(:title="item.provider_name") {{ item.provider_name }}
                  td
                    b-form-input.text-center(
                      :id="'s_' + item.provider_code + index"
                      size="sm"
                      type="number"
                      step="0.1"
                      min="0"
                      v-model="item.self_rebate_rate"
                      @update="srrCopyAll"
                    )
                  td
                    b-form-input.text-center(
                      :id="'d_' + item.provider_code + index"
                      size="sm"
                      type="number"
                      step="0.1"
                      min="0"
                      v-model="item.downline_rebate_rate"
                    )
                  td.actions.text-center
                    span
                      a.fa.fa-save.btn.btn-ssm.btn-primary(href="javascript:void(0)" @click="confirmEditVipProvider(item)" :title="$t('ui.save')")
        template(v-else)
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="14%")
                    span(:title="$t('ui.vip_name')") {{ $t("ui.vip_name") }}
                  th.text-right(width="8%")
                    span(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                  th.text-right(width="8%")
                    span(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                  th.text-right(width="10%")
                    span(:title="$t('ui.maintain_deposit')") {{ $t("ui.maintain_deposit") }}
                  th.text-right(width="10%")
                    span(:title="$t('ui.maintain_turnover')") {{ $t("ui.maintain_turnover") }}
                  th(width="7%")
                    span(:title="$t('ui.reward_type')") {{ $t("ui.reward_type") }}
                  th.text-right(width="8%")
                    span(:title="$t('ui.cash')") {{ $t("ui.cash") }}
                  th(width="10%")
                    span(:title="$t('ui.campaign_id')") {{ $t("ui.campaign_id") }}
                  th(width="7%")
                    span(:title="$t('ui.cs')") {{ $t("ui.cs") }}
                  th(width="7%")
                    span(:title="$t('ui.social_platform')") {{ $t("ui.social_platform") }}
                  th(width="8%")
                    span(:title="$t('ui.action_by')") {{ $t("ui.action_by") }}
              tbody.clusterize-content
                tr(v-if="vipList.length == 0")
                  td(colspan="12").text-center
                    span {{ $t('message.no_data_available') }}
                //- tr(
                //-   v-for="(item, index) in vipList"
                //-   draggable="true"
                //-   @dragstart="handleDragStart($event, index)"
                //-   @dragover.prevent
                //-   @dragenter="handleDragEnter($event, index)"
                //-   @dragleave="handleDragLeave"
                //-   @drop="handleDrop($event, index)"
                //-   @dragend="handleDragEnd"
                //-   :id="item.vip_id"
                //- )
                tr(v-for="(item, index) in vipList" :id="item.vip_id")
                  td.text-center
                    span(:title="index + 1") {{ index + 1 }}
                  //- td.grabbable
                  td
                    template(v-if="isEditAccess")
                      //- span(v-if="index != 0" :title="item.vip_name")
                      //-   i.fas.fa-crown.mr-1(:class="'trophy' + item.vip_id")
                      //-   a.text-primary.font-weight-bold.text-decoration-none(v-if="item.vip_name" href="javascript:void(0)" @click="onEditVip(item)" :title="$t('ui.edit_vip')") {{ item.vip_name }}
                      //- span(v-else :title="item.vip_name") 
                      //-   i.fas.fa-crown.mr-1(:class="'trophy' + item.vip_id")
                      //-   span.font-weight-bold {{ item.vip_name }}
                      span(:title="item.vip_name") 
                        b-img.fiximg.pointer.mr-1(:src="imagePath + item.image_url" @error="handleImageError" @click="onEditVipIcon(item)")
                        a.text-primary.font-weight-bold.text-decoration-none(v-if="item.vip_name" href="javascript:void(0)" @click="onEditVip(item)" :title="$t('ui.edit_vip')") {{ item.vip_name.toUpperCase() }}
                      .float-right
                        a.fas.fa-list.btn.btn-ssm.btn-info(href="javascript:void(0)" @click="setVipId(item)" :title="$t('ui.edit_vip_provider')")
                    template(v-else)
                      span(:title="item.vip_name") 
                        b-img.fiximg.mr-1(:src="imagePath + item.image_url" @error="handleImageError")
                        span.font-weight-bold {{ item.vip_name }}
                  td.text-right
                    span(:title="$n(item.deposit, 'currency')") {{ item.deposit != null ? $n(item.deposit, 'currency') : null }}
                  td.text-right
                    span(:title="$n(item.turnover, 'currency')") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
                  td.text-right
                    span(:title="$n(item.maintain_deposit, 'currency')") {{ item.maintain_deposit != null ? $n(item.maintain_deposit, 'currency') : null }}
                  td.text-right
                    span(:title="$n(item.maintain_turnover, 'currency')") {{ item.maintain_turnover != null ? $n(item.maintain_turnover, 'currency') : null }}
                  td
                    span(:title="item.reward_type") {{ item.reward_type ? item.reward_type : "-" }}
                  td.text-right
                    span(:title="$n(item.cash, 'currency')") {{ item.cash != null ? $n(item.cash, 'currency') : null }}
                  td
                    span(:title="item.campaign_id") {{ item.campaign_id }}
                  td
                    span(:title="item.cs") {{ item.cs }}
                  td
                    span(:title="item.social_platform") {{ item.social_platform }}
                  td
                    span(:title="item.action_by") {{ item.modified_by ? item.modified_by : item.created_by }}   
  addvip(@clicked="addVip" :operatorID="operatorID" @failed="handleFailed")
  editvip(ref="editvip" :item="selectedVip" :operatorID="operatorID" @clicked="afterEditVip" @failed="handleFailed")  
  editvipicon(ref="editvipicon" :item="selectedVip" :operatorID="operatorID" @clicked="afterEditVipIcon" @failed="handleFailed")  
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ValidateResult from "@/library/ValidateResult";
import addvip from "@/components/vip/addVip.vue";
import editvip from "@/components/vip/editVip.vue";
import editvipicon from "@/components/vip/editVipIcon.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    addvip,
    editvip,
    editvipicon
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    sortKey: "account_id",
    sortType: "asc",
    vipList: [],
    vipProviderList: [],
    vipCount: 0,
    selectedVipId: null,
    selectedVipName: null,
    selectedVip: null,
    pageLvl: "vip",
    srr: false,
    drr: false,
    imagePath: config.viewImageUrl,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    loginId() {
      return this.$store.getters.loginId;
    },
    vipCountMax() {
      return config.vipCountMax;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_vip");
    }
  },
  mounted: function() {
    // this.refresh()
  },
  methods: {
    refresh() {
      this.pageLvl = 'vip';
      if(this.isOperator) {
        this.getVipList(this.loginId)
        this.getVipCount(this.loginId)
      } else {
        this.getVipList(this.operatorID)
        this.getVipCount(this.operatorID)
      }
    },
    redirect() {
      this.$router.push("/account/operator");
    },
    onEditVipIcon: function(e) {
      this.selectedVip = e;
      this.$refs.editvipicon.$refs.editVipIcon.show();
    },
    afterEditVipIcon: function() {
      this.getVipList(this.operatorID);
      this.$helpers.showDialog(this.$t("ui.combine.edit_vip_icon"), this.$t("message.success"), "success");
    },
    onEditVip: function(e) {
      this.selectedVip = e;
      this.$refs.editvip.$refs.editVip.show();
    },
    afterEditVip: function() {
      this.getVipList(this.operatorID);
      this.$helpers.showDialog(this.$t("ui.combine.edit_vip"), this.$t("message.success"), "success");
    },
    addVip: function() {
      this.getVipList(this.operatorID);

      this.$helpers.showDialog(this.$t("ui.combine.add_vip"), this.$t("message.success"), "success");
    },
    getVipList: function() {
      let url = config.vipListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if (response.data.dt.length > 0) {
                  this.vipList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getVipCount: function() {
      let url = config.vipCountUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.vipCount = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    backToVipList() {
      this.pageLvl = "vip";
      this.selectedVipId = null;
      this.selectedVipName = null;
      this.srr = false;
      this.drr = false;
      this.getVipList();
    },
    setVipId: function (e) {
      this.selectedVipId = e.vip_id;
      this.selectedVipName = e.vip_name;
      this.getVipProviderList();
    },
    getVipProviderList: function() {
      let url = config.vipProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        vip_id: this.selectedVipId,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.pageLvl = "vipProvider";
                if (response.data.dt.length > 0) {
                  this.vipProviderList = response.data.dt;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmVipProviderRebateBatch: function() {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.vip_provider_rebate_batch_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            let modifiedObj = this.vipProviderList.map(item => {
              const { provider_name, ...rest } = item;
                return { vip_id: this.selectedVipId, ...rest };
            });
            this.vipProviderRebateBatch(modifiedObj);
          } else {
            this.getVipProviderList();
          }
        });
    },
    vipProviderRebateBatch: function(csv) {
      let url = config.vipProviderEditBatchUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        vip_provider_rebate: csv
      };

      this.feedback.success = true;
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getVipProviderList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    confirmCopyAll: function(mode, e, modeMsg) {
      let proceed = false;
      let firstProvider = this.vipProviderList.length > 0 ? this.vipProviderList[0].provider_code : ""
      if(mode == 'srr') {
        proceed = this.srr
      } else {
        proceed = this.drr
      }

      if(proceed) {
        this.$helpers
          .alert({
            title: this.$t("ui.status"),
            text: this.$t("message.copy_rebate_rate_all_confirm", { name: this.$t("ui." + modeMsg), provider: firstProvider }),
            type: "question",
            showCancelButton: true
          })
          .then(result => {
            if (result.value) {
              if(mode == 'srr'){
                this.setInput('srr', true)
                this.srrCopyAll()
              } else {
                this.setInput('drr', true)
                this.drrCopyAll()
              }
              // this.getVipProviderList();
            } else {
              if(mode == 'srr'){
                this.srr = false
              } else {
                this.drr = false
              }
            }
          });
      } else {
        if(mode == 'srr'){
          this.setInput('srr', false)
          this.srr = false
        } else {
          this.setInput('drr', false)
          this.drr = false
        }
      }
    },
    setInput(mode, isDisabled) {
      let list = this.vipProviderList.slice(1);
      // Loop through the object
      list.forEach((obj, index) => {
        let inputId = mode == 'srr' ? 's_' + obj.provider_code + (index+1) : 'd_' + obj.provider_code + (index+1);
        let inputElement = document.getElementById(inputId);
        if (inputElement) {
          inputElement.disabled = isDisabled;
        }
      })
    },
    srrCopyAll() {
      if(this.srr) {
        let list = this.vipProviderList.slice(1);
        let srrbase = this.vipProviderList[0].self_rebate_rate
        // Loop through the object
        list.forEach((obj, index) => {
          this.vipProviderList[index+1].self_rebate_rate = srrbase;
        })
      }
    },
    drrCopyAll() {
      if(this.drr) {
        let list = this.vipProviderList.slice(1);
        let drrbase = this.vipProviderList[0].downline_rebate_rate
        // Loop through the object
        list.forEach((obj, index) => {
          this.vipProviderList[index+1].downline_rebate_rate = drrbase;
        })
      }
    },
    confirmEditVipProvider: function(e) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.edit_vip_confirm", { name: e.provider_code }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.editVipProvider(e);
          } else {
            this.getVipProviderList();
          }
        });
    },
    editVipProvider: function(e) {
      let url = config.vipProviderEditUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        vip_id: this.selectedVipId,
        provider_code: e.provider_code,
        self_rebate_rate: e.self_rebate_rate,
        downline_rebate_rate: e.downline_rebate_rate
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getVipProviderList();
                this.$helpers.showDialog(this.$t("ui.status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getVipProviderList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleImageError(event) {
      event.target.src = '/assets/img/vip/vip_default.png'; // Set fallback image
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>

<style lang="scss" scoped>
.fiximg {
  height:13px;
  width:16px;
}
</style>